/**
 * GP portal auth/session utilities. Fully separate from normal auth:
 * GP token lives under its own storage key and is never written to the
 * normal 'token' slot (two-way separation mirrors the backend).
 */

const GP_TOKEN_KEY = 'gp_token';
const GP_USER_KEY = 'gp_user';

export interface GpUser {
  _id: string;
  name: string;
  email?: string;
  providerNumber: string;
  role: 'GP';
}

export const setGpSession = (token: string, user: GpUser): void => {
  sessionStorage.setItem(GP_TOKEN_KEY, token);
  sessionStorage.setItem(GP_USER_KEY, JSON.stringify(user));
};

export const getGpToken = (): string | null => sessionStorage.getItem(GP_TOKEN_KEY);

export const getGpUser = (): GpUser | null => {
  try {
    const raw = sessionStorage.getItem(GP_USER_KEY);
    return raw ? (JSON.parse(raw) as GpUser) : null;
  } catch {
    return null;
  }
};

export const clearGpSession = (): void => {
  sessionStorage.removeItem(GP_TOKEN_KEY);
  sessionStorage.removeItem(GP_USER_KEY);
};

export const isValidGp = (): boolean => Boolean(getGpToken());
